import { Requester } from './Requester';
import { ILoanRecord, IManifest } from '../types';

export const PostOrganizationLoan = async ({
    clientId,
    loan
}: {
    clientId: string;
    loan: IManifest;
}): Promise<ILoanRecord | null> => {
    try {
        const response = await Requester<ILoanRecord | null>({
            path: `organizations/${clientId}/loans`,
            method: 'POST',
            payload: loan
        });

        return response && Object.hasOwn(response, '_id') ? (response as ILoanRecord) : null;
    } catch (e) {
        console.error('Create organization loan request failed');
        return Promise.reject(e);
    }
};
